import React from 'react';

import Validity from 'app/components/icons/Validity';
import ReservationDetail, {
  ReservationDetailProps,
} from 'app/components/ReservationSummary/ReservationDetail';
import TextLabel from 'app/components/ReservationSummary/TextLabel';
import { date } from 'app/services/ReservationHelper';
import { tID } from 'app/services/TestHelper';

export type ReservationDetailDateProps = Omit<ReservationDetailProps, 'Icon'> & {
  dateTime: string | undefined;
  color?: string;
  isMuted?: boolean;
};

export default function ReservationDetailDate({
  dateTime,
  isMuted,
  ...props
}: ReservationDetailDateProps) {
  const day = dateTime ? date(dateTime) : null;

  return (
    <ReservationDetail Icon={Validity} testID={tID('ReservationDetailDate')} {...props}>
      <TextLabel isMuted={isMuted}>{day ? day.format('dddd') : ''}</TextLabel>
      <TextLabel isMuted={isMuted}>{day ? day.format('MMM D') : ''}</TextLabel>
    </ReservationDetail>
  );
}
